import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as LegacyThemeProvider } from '@material-ui/core/styles';

import { trTR } from '@material-ui/data-grid';
import { trTR as coreTrTR } from '@mui/material/locale';

// Both @mui/material and the legacy @material-ui/core share emotion's ThemeContext,
// so the theme must come from @mui/material's createTheme -- only that one provides
// theme.applyStyles, which @mui/material v5.18 components require.
const CustomThemeProvider = ({ children }) => {

    const theme = createTheme({
        palette: {
            primary: {
                main: "#C03A2A",
                contrastText: "#efefef"
            },
            secondary: {
                main: '#3F3F3F',
                contrastText: "#efefef"

            },
            background: {
                default: "#efefef",
            }
        },
    },
        coreTrTR,
        trTR,
    )

    return (
        <ThemeProvider theme={theme}>
            <LegacyThemeProvider theme={theme}>
                {children}
            </LegacyThemeProvider>
        </ThemeProvider>
    )

}

export default CustomThemeProvider
